var _path, _path2, _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgLock = function SvgLock(props) {
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8424 3.68968C46.8424 2.84387 46.1567 2.1582 45.3109 2.1582H16.4258C15.58 2.1582 14.8943 2.84387 14.8943 3.68968V27.1448C14.8943 27.9906 15.58 28.6763 16.4258 28.6763H40.0113C40.2998 28.6763 40.5823 28.7578 40.8265 28.9113L44.4957 31.2185C45.5156 31.8599 46.8424 31.1268 46.8424 29.9221V3.68968Z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.21179,
    y: 7.1361,
    width: 35.6067,
    height: 33.4993
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.55px)",
      clipPath: "url(#lock_svg__bgblur_0_182_62445_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 1.09241,
    d: "M39.6401 8.22852C40.2399 8.22859 40.7259 8.71473 40.7261 9.31445V34.7148C40.7261 35.3147 40.24 35.8017 39.6401 35.8018H18.7817C15.6498 35.8018 12.5802 36.6819 9.92432 38.3418L8.13525 39.46C7.77354 39.6859 7.3042 39.4255 7.3042 38.999V9.31445C7.30434 8.71468 7.79131 8.22852 8.39111 8.22852H39.6401Z",
    fill: "url(#".concat(_id3, ")"),
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3042 9.75999C7.3042 8.91418 7.98986 8.22852 8.83568 8.22852H39.1945C40.0403 8.22852 40.726 8.91418 40.726 9.75999V34.27C40.726 35.1158 40.0403 35.8015 39.1945 35.8015H14.4278C14.1407 35.8015 13.8595 35.8821 13.6161 36.0343L9.64736 38.5147C8.62732 39.1522 7.3042 38.4189 7.3042 37.216V9.75999Z",
    fill: "url(#".concat(_id4, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8336 27.8058H20.3592C19.6118 27.8058 19.0002 27.1993 19.0002 26.4581V21.2917C19.0002 20.5504 19.6118 19.9439 20.3592 19.9439C20.4843 19.9439 20.5857 19.8425 20.5857 19.7174V18.3715C20.6537 16.4622 22.2618 14.9348 24.2097 15.0021C26.067 15.0695 27.5392 16.5296 27.6071 18.3715V19.7174C27.6071 19.8425 27.7086 19.9439 27.8336 19.9439C28.5811 19.9439 29.1926 20.5504 29.1926 21.2917V26.4581C29.1926 27.1993 28.5811 27.8058 27.8336 27.8058ZM23.3037 24.998C23.3037 25.4248 23.6661 25.7842 24.0964 25.7842C24.5268 25.7842 24.8892 25.4248 24.8892 24.998V22.7517C24.8892 22.3249 24.5268 21.9655 24.0964 21.9655C23.6661 21.9655 23.3037 22.3249 23.3037 22.7517V24.998ZM26.0217 18.5962C26.0217 18.5512 26.0217 18.5288 26.0217 18.4838C26.0217 17.4281 25.161 16.5745 24.0964 16.5745C23.0319 16.5745 22.1712 17.4281 22.1712 18.4838C22.1712 18.5288 22.1712 18.5512 22.1712 18.5962V19.3862C22.1712 19.6942 22.4209 19.9439 22.7289 19.9439H25.4639C25.772 19.9439 26.0217 19.6942 26.0217 19.3862V18.5962Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id,
    transform: "translate(-6.21179 -7.1361)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6401 8.22852C40.2399 8.22859 40.7259 8.71473 40.7261 9.31445V34.7148C40.7261 35.3147 40.24 35.8017 39.6401 35.8018H18.7817C15.6498 35.8018 12.5802 36.6819 9.92432 38.3418L8.13525 39.46C7.77354 39.6859 7.3042 39.4255 7.3042 38.999V9.31445C7.30434 8.71468 7.79131 8.22852 8.39111 8.22852H39.6401Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 17.9499,
    y1: 4.10918,
    x2: 46.6319,
    y2: 34.787,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CEFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 2.64361,
    y1: 10.4119,
    x2: 6.7446,
    y2: 41.7997,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E6FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC2FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 37.5295,
    y1: 10.2571,
    x2: 7.71928,
    y2: 42.3363,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2FF"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CEFF"
  })))));
};
export default SvgLock;